<template>
  <div class="d-flex flex-column gr-6">
    <div
      class="px-2"
      :class="isMobile ? 'text-h6' : 'text-h5 text-center'"
    >
      {{ t('С нами работают', options) }}
    </div>

    <div
      v-if="isMobile"
      class="our-partners-list our-partners-list--sliding"
    >
      <div
        v-for="(partnersByLine, indexLine) in partnersByLines"
        :key="indexLine"
        :style="{ animationPlayState: animationState }"
      >
        <div
          v-for="(partner, index) in partnersByLine"
          :key="index"
          class="bg-gray-0 pa-5 elevation-1 rounded-sm"
        >
          <v-img
            :src="partner"
            height="48"
            width="108"
            alt="/"
            contain
          />
        </div>
      </div>
    </div>
    <div
      v-else
      class="our-partners-list"
    >
      <div
        v-for="(partner, index) in partners"
        :key="index"
        class="bg-gray-0 pa-5 elevation-1 rounded-sm"
      >
        <v-img
          class="mx-auto"
          :src="partner"
          height="82"
          width="171"
          alt="/"
          contain
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref } from 'vue'
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/components/pages/profile/doctors/register/index/types'
import useContextStore from 'src/store/useContextStore'

const { t, language } = I18NextVue
const options = { ns: language }

const { context }: ContextStore = useContextStore()
const isMobile = computed(() => context.flavour === 'mobile')

const partners = [
  '/static/_v1/pd/logos/lpus/cooperation/0.png',
  '/static/_v1/pd/logos/lpus/cooperation/1.png',
  '/static/_v1/pd/logos/lpus/cooperation/2.png',
  '/static/_v1/pd/logos/lpus/cooperation/3.png',
  '/static/_v1/pd/logos/lpus/cooperation/4.png',
  '/static/_v1/pd/logos/lpus/cooperation/5.png',
  '/static/_v1/pd/logos/lpus/cooperation/6.png',
  '/static/_v1/pd/logos/lpus/cooperation/7.png',
  '/static/_v1/pd/logos/lpus/cooperation/8.png',
  '/static/_v1/pd/logos/lpus/cooperation/9.png',
  '/static/_v1/pd/logos/lpus/cooperation/10.png',
  '/static/_v1/pd/logos/lpus/cooperation/11.png',
  '/static/_v1/pd/logos/lpus/cooperation/12.png',
  '/static/_v1/pd/logos/lpus/cooperation/13.png',
  '/static/_v1/pd/logos/lpus/cooperation/14.png',
  '/static/_v1/pd/logos/lpus/cooperation/15.png',
  '/static/_v1/pd/logos/lpus/cooperation/16.png',
  '/static/_v1/pd/logos/lpus/cooperation/17.png',
  '/static/_v1/pd/logos/lpus/cooperation/18.png',
  '/static/_v1/pd/logos/lpus/cooperation/19.png',
]

const partnersByLines = computed(() => {
  const halfIndex = Math.floor(partners.length / 2)
  const ratesByLine = [partners.slice(0, halfIndex), partners.slice(halfIndex)]

  return ratesByLine.map(i => [...i, ...i])
})
const animationState = ref<'paused' | undefined>('paused')

onMounted(() => {
  animationState.value = undefined
})
</script>

<style lang="scss" scoped>
@keyframes sliding-line {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(calc(-50% - 8px));
  }
}

.our-partners-sliding-list {
  display: grid;
  gap: 16px;
}

.our-partners-list {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(178px, 1fr));
  padding: 4px 0;

  &--sliding {
    overflow: hidden;
    grid-template-columns: repeat(1, 1fr);

    & > * {
      display: inline-flex;
      gap: inherit;
      animation: 20s linear infinite sliding-line;

      &:nth-child(2) > *:first-child {
        margin-left: -82px;
      }
    }
  }
}
</style>
